import { saveWidgetStateToStorage } from "./storage";
import {
  ActionTypes,
  WidgetContextActions,
  WidgetContextState,
  WidgetCollection,
} from "./widgettypes";

export class WidgetStateHandler {
  state: WidgetContextState;

  constructor(initialState: WidgetContextState) {
    this.state = initialState;
  }

  [ActionTypes.ADD_WIDGET](action: WidgetContextActions) {
    const widgetId = action.payload.id;

    this.setWidgetState({
      [widgetId]: {
        ...action.payload,
        position: {
          ...action.payload.position,
          index:
            action.payload.position.index ?? Object.keys(this.state).length,
        },
      },
    });
  }

  [ActionTypes.REMOVE_WIDGET](action: WidgetContextActions) {
    const { [action.payload]: toRemove, ...restOfWidgets } = this.state.widgets;

    this.state = {
      widgets: restOfWidgets,
    };
  }

  [ActionTypes.SWAP_WIDGETS](action: WidgetContextActions) {
    const { source, destination } = action.payload;
    const sourceWidget = this.state.widgets[source];
    const destinationWidget = this.state.widgets[destination];

    this.setWidgetState({
      [source]: {
        ...sourceWidget,
        position: {
          ...sourceWidget.position,
          index: destinationWidget.position.index,
        },
      },
      [destination]: {
        ...destinationWidget,
        position: {
          ...destinationWidget.position,
          index: sourceWidget.position.index,
        },
      },
    });
  }

  [ActionTypes.RESET_DATA_TABLE](action: WidgetContextActions) {
    const id = action.payload;
    this.setWidgetState({
      [id]: {
        ...this.state.widgets[id],
        refresh: true,
      },
    });
  }

  [ActionTypes.RESET_REFRESH](action: WidgetContextActions) {
    const id = action.payload;
    this.setWidgetState({
      [id]: {
        ...this.state.widgets[id],
        refresh: false,
      },
    });
  }

  setWidgetState = (newState: Partial<WidgetCollection>) => {
    this.state = {
      ...this.state,
      widgets: {
        ...this.state.widgets,
        ...(newState as WidgetCollection),
      },
    };
  };

  // returns state outside of the class reference
  getState = () => ({ ...this.state });
}

export const WidgetContextReducer = (
  state: WidgetContextState,
  action: WidgetContextActions
) => {
  const stateHandler = new WidgetStateHandler(state);
  if (!stateHandler[action.type]) {
    throw new Error("Invalid action type");
  }

  stateHandler[action.type](action);

  const stateUpdate = stateHandler.getState();

  saveWidgetStateToStorage(stateUpdate);

  return stateUpdate;
};
